import React from 'react'
import { Helmet } from 'react-helmet-async'
import Header from '../components/Header'
import Footer from '../components/Footer'
import PageMeta from '../components/PageMeta'

const PortfolioPage = () => {
  const items = [
    { title: 'Dekraiol - dekraiol.co.za', desc: 'Comprehensive professional services platform offering HSE & ISO consulting, auditing, training, and staff placement. Features modern responsive design with integrated CMS and professional imagery showcasing safety and sustainability.', link: 'https://dekraiol.co.za', image: '/images/screenshots/Dekraiol.co.za.png' },
    { title: 'Dekraiol Cloud Platform - dekraiol.net', desc: 'Integrated cloud platform combining Nextcloud for file management, SuiteCRM for customer relationships, n8n for workflow automation, and draw.io for collaborative diagramming. Enterprise-grade solution for teams requiring unified productivity and business operations.', link: 'https://dekraiol.net', image: '/images/screenshots/Dekraiol.net.png' },
    { title: 'Sports Legacy Company - WordPress Theme', desc: 'Custom WordPress theme for a B-BBEE compliance and sports development company. Features dynamic hero sections, impact statistics, partner showcases, and comprehensive programme information. Modern design with full responsiveness and smooth animations.', link: 'https://sportlegacycompany.co.za/', image: '/images/screenshots/slc-demo.png' }
  ]

  return (
    <div>
      <PageMeta 
        title="Web Design Portfolio Centurion | Case Studies & Results | RDS Studio"
        description="View our Centurion web design portfolio. Real results: 60+ #1 Google rankings, 2.5x conversion increases, 15–40% performance improvements. See what we've built."
        canonical="https://rdsstudio.co.za/portfolio"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": "https://rdsstudio.co.za/portfolio#webpage",
            "url": "https://rdsstudio.co.za/portfolio",
            "name": "Digital Projects & Case Studies | RDS Studio Portfolio",
            "description": "Portfolio of web design, cloud infrastructure and digital marketing projects by RDS Studio in Centurion, South Africa.",
            "isPartOf": { "@id": "https://rdsstudio.co.za/#website" },
            "about": { "@id": "https://rdsstudio.co.za/#organization" },
            "inLanguage": "en-ZA"
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "name": "RDS Studio Portfolio",
            "description": "Selected web design and digital marketing case studies by RDS Studio",
            "numberOfItems": items.length,
            "itemListElement": items.map((item, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "item": {
                "@type": "CreativeWork",
                "name": item.title,
                "description": item.desc,
                "url": item.link,
                "image": `https://rdsstudio.co.za${item.image}`,
                "creator": { "@id": "https://rdsstudio.co.za/#organization" }
              }
            }))
          })}
        </script>
      </Helmet>
      <Header />
      <main className="main-content">
        <section className="section portfolio">
          <div className="section-inner">
            <h1 className="title title-h2">Digital Products<br/>That Deliver ROI</h1>
            <p className="description">Selected case studies showing how we improved performance, conversions and user experience for SaaS, e-commerce and B2B brands. Each project led to measurable business outcomes.</p>

            <div className="portfolio-grid" style={{ marginTop: '2rem' }}>
              {items.map((it, idx) => (
                <div className="portfolio-item" key={idx}>
                  <div className="portfolio-image">
                    {it.image ? (
                      <img 
                        src={it.image} 
                        alt={it.title}
                        loading="lazy"
                        decoding="async"
                        style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '8px' }}
                      />
                    ) : (
                      <div style={{ width: '100%', height: '100%', background: 'linear-gradient(45deg, var(--color-quaternary), var(--color-primary))', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px' }}>
                        <i className="fas fa-briefcase" style={{ fontSize: '3rem', color: 'var(--color-text)'}}></i>
                      </div>
                    )}
                  </div>
                  <h3>{it.title}</h3>
                  <p>{it.desc}</p>
                  <a className="btn btn-secondary" href={it.link} target="_blank" rel="noopener noreferrer">View Case Study</a>
                </div>
              ))}
            </div>

          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default PortfolioPage
